import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from './IconLinkGroup.styles.js';

var defaultProps = {
  role: "list"
};
var IconLinkGroupPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;
  var direction = props.direction,
    _props$role = props.role,
    role = _props$role === void 0 ? "list" : _props$role,
    id = props.id,
    className = props.className,
    noMargin = props.noMargin,
    children = props.children,
    viewport = props.viewport,
    maxWidth = props.maxWidth,
    centeredLayout = props.centeredLayout,
    horizontalAlignment = props.horizontalAlignment;
  var isDirectionVertical = direction === "vertical" || direction === "flip-xs" && viewport === "xs" || direction === "flip-sm" && (viewport === "sm" || viewport === "xs") || direction === "flip-md" && (viewport === "md" || viewport === "sm" || viewport === "xs");
  var noText = direction === "collapse-xs" && viewport === "xs" || direction === "collapse-sm" && (viewport === "sm" || viewport === "xs") || direction === "collapse-md" && (viewport === "md" || viewport === "sm" || viewport === "xs") || direction === "textfield" || direction === "table";
  var hasHover = direction !== "table" && direction !== "textfield" && direction !== "header-menu" && direction !== "pagination";
  // eslint-disable-next-line no-nested-ternary
  var hover = hasHover ?
  // eslint-disable-next-line no-nested-ternary
  isDirectionVertical ? "right" : direction === "vertical-left" ? "left" : "top" : undefined;
  var spacing = {
    table: "table",
    textfield: "textfield"
  }[direction] || "normal";
  var noWrap = direction === "textfield" || direction === "header-menu" || direction === "table";
  var align = centeredLayout ? "center" : horizontalAlignment;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    style: maxWidth && {
      maxWidth: maxWidth
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(isDirectionVertical ? "vertical" : "horizontal"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__pagination"), direction === "pagination"), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__hover-").concat(hover), hover), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(spacing), spacing), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__no-text"), noText), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__no-wrap"), noWrap), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__align-").concat(align), align), _cleanupClassObject2)),
    role: role,
    id: id
  }, children));
}, defaultProps);
IconLinkGroupPresentation.displayName = "IconLinkGroupPresentation";

export { IconLinkGroupPresentation, defaultProps };
